import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import ConfigETC from "../Class/ConfigETC.json";
import {
        Bind_Select_Status 
       ,Bind_Presets_Calendar 
       ,Class_ETC_MsgError
       ,formatDate 
       ,datagridtoolbarOptions
       ,pdfExportProperties_Reportsummary
       ,excelExportProperties_Reportsummary
       ,csvExportProperties_Reportsummary
       ,ConvertMiniutDuration_calbyconfig
       ,Returnhidevalue
       ,Class_ETC_SessionTimeOut
       ,date_pickerStyle
      } from "../Class/Class_Etc";
import { DateRangePickerComponent } from '@syncfusion/ej2-react-calendars';
import Select from "react-select";
import SelectTaskMultiGroup from "../Library/Select_TaskMultiGroup";
import SelectStaff from "../Library/Select_Staff";
import SelectCustomer from "../Library/Select_Customer";
import makeAnimated from "react-select/animated";
import {
  GridComponent,ColumnsDirective,ColumnDirective,Page,Sort,Inject,Toolbar,PdfExport,ExcelExport,Group,Resize,Reorder,
} from "@syncfusion/ej2-react-grids"; //synfusion data grid

import { CP_CheckPermission } from "../Class/Class_Permission"

import { updateSampleSection } from "../Main/Sample-base"; //synfusion data grid

import { customStylesSelect } from "../Class/Class_Etc"

import SelectProjectByCustomerBySearch from "../Library/Select_ProjectByCustomer";

/*  Update By Krisana : 07-05-2024 - แก้ไขโดยเพิ่มเงื่อนไขการค้นหาด้วย Customer 
    Update By Krisana : 13-05-2024 - แก้ไข DDL Project ให้ Filter ตาม cus_id 
    Update By POOM : 14-05-2024 : 
      - เพิ่ม service ot เข้ามา เพราะฉนั้น ถ้าไม่มี service ot จะปิดทุกอย่างที่เกี่ยวกับ OT ออกเลย ไม่ให้บันทึกไม่ให้เห็นข้อมูล

*/

function Report_sumByTasks() {

  const isSVOT = CP_CheckPermission("service_list" , ["ot"],false,false);
  const [isFirst, setIsFirst] = useState(true);
  const [isLoadProgress, setIsLoadProgress] = useState(true);
  const [isLoadedConfigData, setIsLoadedConfigData] = useState(false);
  const [_listReport, set_SetlistReport] = useState(false)
  const [configData, setConfigData] = useState([]);
  const [listReport, setListReport] = useState([]);

  const animatedComponents = makeAnimated();

  const [_sProject, set_SProject] = useState([]);
  const [_sStaff, set_SStaff] = useState([]);
  const [_sCustomer, set_SCustomer] = useState(null);
  const [selectedOptionsTask, setSelectedOptionsTask] = useState([]);
  const [_sStatus, set_SStatus] = useState([]);
  const [iscntreset, setIscntreset] = useState(0);
  const dataPresets = Bind_Presets_Calendar();

  const [DaterangExport, setDaterangExport] = useState("");
  const [StaffExport, setStaffExport] = useState("");
  const [StatusExport, setStatusExport] = useState("");
  const [ProjectExport, setProjectExport] = useState("");
  const [CustomerExport, setCustomerExport] = useState("");
  const [TaskExport, setTaskExport] = useState("");

  const [isPstimesheetcostsview, setIsPstimesheetcostsview] = useState(false);

  const [bindProjectBycusid, setBindProjectBycusid] = useState(0);

  //#region ###################  Open on load               ###################
    useEffect(() => {
      if (isFirst === true) {
        GetConfig();
        if (isLoadedConfigData === true) {
          let ckpermission = CP_CheckPermission("report" , ["report_tasks_view"] , false , true)   
          if(ckpermission === true) {
            setIsPstimesheetcostsview(CP_CheckPermission("main" , ["timesheet_costs_view"] , false , false));
            updateSampleSection();
            setIsFirst(false);
            setIsLoadProgress(false);
          }
        }
      };
    //eslint-disable-next-line
    },[isLoadedConfigData]);
    
    useEffect(() => {
      window.addEventListener('keydown', handleKeyDown);
      // Clean up the event listener when the component unmounts
      return () => {
        window.removeEventListener('keydown', handleKeyDown);
      };
    }, []);
  
    const handleKeyDown = (event) => {
      if (event.key === 'Enter') {
        document.getElementById("Search_Report").click();
      }
    };

    async function GetConfig() {
      await fetch("../ConfigData.json")
        .then((res) => res.json())
        .then((data) => {
          setConfigData(data);
          setIsLoadedConfigData(true);
        })
        .catch((err) => err);
    }
  //#endregion
 
  //#region ###################  Bind Data   ########################

  function Bindendfunction_SP(){
    setIsLoadProgress(false)
  }

  async function BindList_Report(_callback) {

      let sProject = "";
      if (_sProject.length > 0) {
        for (let i = 0; i < _sProject.length; i++) {
          sProject =
          sProject +
            (sProject === "" ? "" : ",") +
            _sProject[i].value;
        }
      }

      let sProject_export = "";
      if (_sProject.length > 0) {
        for (let i = 0; i < _sProject.length; i++) {
          sProject_export =
          sProject_export +
            (sProject_export === "" ? "" : ",") +
            _sProject[i].label;
        }
      }

      let sStaff = "";
      if (_sStaff.length > 0) {
        for (let i = 0; i < _sStaff.length; i++) {
          sStaff =
          sStaff +
            (sStaff === "" ? "" : ",") +
            _sStaff[i].value;
        }
      }

      let sStaff_export = "";
        if (_sStaff.length > 0) {
          for (let i = 0; i < _sStaff.length; i++) {
            sStaff_export =
            sStaff_export +
              (sStaff_export === "" ? "" : ",") +
              _sStaff[i].label;
          }
        }

      let sTask = "";
      if (selectedOptionsTask.length > 0) {
        for (let i = 0; i < selectedOptionsTask.length; i++) {
          sTask =
          sTask +
            (sTask === "" ? "" : ",") +
            selectedOptionsTask[i].value;
        }
      }

      let sTask_export = "";
      if (selectedOptionsTask.length > 0) {
        for (let i = 0; i < selectedOptionsTask.length; i++) {
          sTask_export =
          sTask_export +
            (sTask_export === "" ? "" : ",") +
            selectedOptionsTask[i].label;
        }
      }
      
      let sStatus = "";
      if (_sStatus.length > 0) {
        for (let i = 0; i < _sStatus.length; i++) {
          sStatus =
          sStatus +
            (sStatus === "" ? "" : ",") +
            _sStatus[i].value;
        }
      }

      let sStatus_export = "";
      if (_sStatus.length > 0) {
        for (let i = 0; i < _sStatus.length; i++) {
          sStatus_export =
          sStatus_export +
            (sStatus_export === "" ? "" : ",") +
            _sStatus[i].label;
        }
      }

      let sCustomer = "";
        let sCustomer_export = "";
        if (_sCustomer !== null) {
          if (_sCustomer.value !== -1){
            sCustomer = _sCustomer.value.toString();
            sCustomer_export = _sCustomer.label;
          }
          else{
            sCustomer = ""
            sCustomer_export = ConfigETC.ddl_All
          }
        }
        
      let Date_start = "";
      let Date_end = "";
      let date_rang = document.getElementById("txt_Date_rang").value;
      if (date_rang !== "")
      {
        const date =  date_rang.split(" - ");
        Date_start = date[0];
        Date_end   = date[1];
      }

      let token = localStorage.getItem("TStoken");
      var myHeaders = new Headers();
      myHeaders.append("Authorization", "Bearer " + token);
      myHeaders.append("Content-Type", "application/json");

      var raw = JSON.stringify({
        "pro_id_str": sProject,
        "task_id_str": sTask,
        "staff_id_str": sStaff,
        "date_start_str": Date_start,
        "date_end_str": Date_end,
        "status_str": sStatus,
        "cus_id_str": sCustomer
      });
      
      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: raw,
        redirect: 'follow'
      };

      await fetch(configData.API_URL + "Report_GetsumByTasks", requestOptions)
        .then((response) => response.json())
        .then((result) => {
          if (result.status_ID === 1) {
            setListReport(result.data);
            setStaffExport(sStaff_export);
            setStatusExport(sStatus_export);
            setProjectExport(sProject_export);
            setCustomerExport(sCustomer_export);
            setDaterangExport(date_rang);
            setTaskExport(sTask_export);
            if (_callback != null) {
              _callback();
            }
          }
          else if (result.status_ID === 2) 
          {
            Class_ETC_SessionTimeOut();
          } 
          else {
            Class_ETC_MsgError(result.status_Desc, null);
            setListReport([]);
            if (_callback != null) {
              _callback();
            }
          }
        })
        .catch((error) => {
          setListReport([]);
          if (_callback != null) {
            _callback();
          }
        });
  }

  //#endregion

  //#region ###################  Onclick ########################

  function onclickReset(){
      setIscntreset((iscntreset) => iscntreset + 1);
      setSelectedOptionsTask([]);
      set_SProject([]);
      set_SStatus([]);
      set_SStaff([]);
      set_SCustomer([]);
      document.getElementById("txt_Date_rang").value = "";
      set_SetlistReport(false)
  };

  function onclickSearch() {
    setIsLoadProgress(true);
    BindList_Report(function () {
      set_SetlistReport(true)
      setIsLoadProgress(false);
    });
  }

  //#endregion

  //#region ###################  HTML ICON CSS in List Report ########################

  function beforePrint(args) {
    let theadEle = gridInstance.element
    .querySelector('.e-gridheader .e-headercontent thead')
    .cloneNode(true);
    let arrOfMOM= theadEle.children;
    args.element
      .querySelector('.e-gridheader .e-headercontent thead')
      .replaceChildren(...[].slice.call(arrOfMOM));
  
    // let tbodyEle = gridInstance.element
    //   .querySelector('.e-gridcontent .e-content tbody')
    //   .cloneNode(true);
    // let arrOfChildren = tbodyEle.children;
    // args.element
    //   .querySelector('.e-gridcontent .e-content tbody')
    //   .replaceChildren(...[].slice.call(arrOfChildren));
  }

  function fabtcTemplate(props) {
    return ( <div>
              <span className="fab fa-btc text-muted"></span>
              &nbsp; {props.headerText}
            </div>);
  }
  function falightTemplate(props) {
    return ( <div>
              <span className="far fa-lightbulb text-muted"></span>
              &nbsp; {props.headerText}
            </div>);
  }
  function faclockTemplate(props) {
    return ( <div>
              <span className="far fa-clock text-muted"></span>
              &nbsp; {props.headerText}
            </div>);
  }

  //#endregion

 //#region ################### Toolbar Export and Export #######################

  let gridInstance;

  function toolbarClick(args) {

    let Project = ProjectExport;
    let Task = TaskExport;
    let Staffs = StaffExport;
    let Daterang = DaterangExport;
    let Status = StatusExport;
    let Customer = CustomerExport;

    const DateExport = new Date();
    const _DateExport = formatDate(DateExport ,"short en","en","","datetimeexport");
    const DateExport_ = formatDate(DateExport ,"short en","en","/","datetime");
    let PDFname = 'RP_sumbytasks_'+_DateExport+'.pdf';
    let Excelname = 'RP_sumbytasks_'+_DateExport+'.xlsx';
    let Csvname = 'RP_sumbytasks_'+_DateExport+'.csv';
    let Report = 'Report 3';
    let Des = 'Timesheet summary by Tasks';

    let isckot = (isSVOT === true ? 0 : 2);
    let iscost = (isPstimesheetcostsview ? 0 : 2);
    let colSpan = 14 - iscost - isckot;
    
    if (gridInstance && args.item.id === 'ExcelExport') {
      gridInstance.excelExport(excelExportProperties_Reportsummary(Excelname,Report,Des,Customer,Project,Task,Staffs,Daterang,Status,DateExport_ , colSpan));
    }
    if (gridInstance && args.item.id === 'PdfExport') {
      gridInstance.pdfExport(pdfExportProperties_Reportsummary(PDFname,Report,Des,Customer,Project,Task,Staffs,Daterang,Status,DateExport_));
    }
    if (gridInstance && args.item.id === 'CsvExport') {
      gridInstance.csvExport(csvExportProperties_Reportsummary(Csvname,Report,Des,Customer,Project,Task,Staffs,Daterang,Status,DateExport_, colSpan));
    }
    if (gridInstance && args.item.id === 'Print') {
      gridInstance.print();
    }
  }

  //#endregion

  //#region ################### Onchange DropDown List #######################

    function SearchonChangevaluesTask(e){
      e === null ? setSelectedOptionsTask([]) : setSelectedOptionsTask(e) ;
    }

    function SearchonChangevaluesProject(e){
      e === null ? set_SProject([]) : set_SProject(e) ;
    }
    
    function SearchonChangevaluesStaff(e){
      e === null ? set_SStaff([]) : set_SStaff(e) ;
    }

    function SearchonChangevaluesCustomer(e){
      set_SCustomer(e)
      if (e === null)
      {
        document.getElementById("hd_cus_id_search").value = "-1";
      }
      else
      {
        document.getElementById("hd_cus_id_search").value = e.value;
      }
      setBindProjectBycusid((bindProjectBycusid) => bindProjectBycusid + 1);
      setIsLoadProgress(true);
    }
  //#endregion
  
  const valueAccessDHM = (field, data, column) => {
    return  ConvertMiniutDuration_calbyconfig(data[field]) ;
  };

  const HideValue = (field, data, column) => {
    return  Returnhidevalue(data[field]) ;
  };

  // const gridClassName = isPstimesheetcostsview && isSVOT  ? 'custom-grid-report-tasks' : 
  //                       !isPstimesheetcostsview && !isSVOT ? 'custom-grid-report-tasks-nocostnoot' : 
  //                       'custom-grid-report-tasks-nocost';

    return (
        <>
      {isLoadProgress && (
        
      <div id="divLoadingProgress" name="divLoadingProgress" align="center" className="divWaiting" >
        <img alt="progress" src="../dist/img/loading.gif" />
      </div>
        )}

      <Helmet>
        <title>Tasks report</title>
      </Helmet>

        {/* Content Wrapper. Contains page content */}
          <div className="content-wrapper">
            {/* Content Header (Page header) */}
            <div className="content-header">
              <div className="row text-center ">
                <div className="col-md-10 offset-md-1 ">
                  <div className="container-fluid">
                    <h1 className=" display-5"> Tasks report </h1>
                    <h6>Timesheet summary by tasks</h6>
                  </div>
                </div>
              </div>
            </div>
            {/* /.content-header */}
            {/* Main content */}
            <section className="content">
              <div className="container-fluid">
                <div className="row">
                  <div className="col-md-10 offset-md-1">
                    <div className="row m-0">
                    <div className="col-lg-4 col-12">
                        <div className="form-group m-0">
                          <label className="text-small p-0 m-0">Customer</label>
                          {isLoadedConfigData && 
                            <SelectCustomer
                              API_URL={configData.API_URL}
                              cus_status={"-1"}
                              selectismulti={false}
                              SelectTextDefault={ConfigETC.ddl_All}
                              resetSelect={iscntreset}
                              onChangevalue={SearchonChangevaluesCustomer}
                              iscloseMenuOnSelect={true}
                            ></SelectCustomer> 
                          }
                        </div>
                        <input type="hidden" id="hd_cus_id_search" ></input>
                      </div>
                      <div className="col-lg-4 col-12">
                        <div className="form-group m-0">
                          <label className="text-small p-0 m-0">Project</label>
                          {isLoadedConfigData && 
                            <SelectProjectByCustomerBySearch
                              API_URL={configData.API_URL}
                              pro_status={"-1"}
                              selectismulti={true}
                              SelectTextDefault={ConfigETC.ddl_All}
                              resetSelect={iscntreset}
                              onChangevalue={SearchonChangevaluesProject}
                              iscloseMenuOnSelect={false}

                              BindProjectBycusid={bindProjectBycusid}
                              hd_cus_id={"hd_cus_id_search"}
                              Bindendfunction={Bindendfunction_SP}
                            ></SelectProjectByCustomerBySearch> 
                          }
                        </div>
                      </div>
                      <div className="col-lg-4 col-12">
                        <div className="form-group m-0">
                          <label className="text-small p-0 m-0">Task</label>
                          {isLoadedConfigData && 
                            <SelectTaskMultiGroup
                              API_URL={configData.API_URL}
                              SelectTextDefault={ConfigETC.ddl_All}
                              resetSelect={iscntreset}
                              onChangevalue={SearchonChangevaluesTask}
                              iscloseMenuOnSelect={false}
                            ></SelectTaskMultiGroup>       
                          }      
                        </div>
                      </div>
                    </div>
                    <div className="row m-0">
                      <div className="col-lg-4 col-sm-6 col-12">
                        <div className="form-group m-0">
                          <label className="text-small p-0 m-0">Staffs</label>
                          {isLoadedConfigData && 
                            <SelectStaff
                              API_URL={configData.API_URL}
                              staff_status={"-1"}
                              selectismulti={true}
                              SelectTextDefault={ConfigETC.ddl_All}
                              resetSelect={iscntreset}
                              onChangevalue={SearchonChangevaluesStaff}
                              iscloseMenuOnSelect={false}
                            ></SelectStaff> 
                          }                          
                        </div>
                      </div>
                      <div className="col-lg-4 col-sm-6 col-12">
                        <div className="form-group m-0">
                          <label className="text-small p-0 m-0">Date</label>
                          <div className="input-group">
                            <DateRangePickerComponent 
                             size="lg"
                             style={date_pickerStyle}
                                id="txt_Date_rang"
                                placeholder='Select a range' 
                                format='dd/MM/yyyy' 
                                presets={dataPresets}
                                strictMode={true}
                            />      
                          </div>
                        </div>
                      </div>
                      <div className="col-lg-4 col-sm-6 col-12">
                        <div className="form-group m-0">
                          <label className="text-small p-0 m-0">Status</label>
                          <Select
                            closeMenuOnSelect={false}
                            components={animatedComponents}
                            placeholder={ConfigETC.ddl_All}
                            isMulti
                            value={_sStatus}
                            options={Bind_Select_Status('Rp_Sum_pro')}
                            menuPortalTarget={document.body}
                            onChange={(e) => set_SStatus(e)}
                           //styles={{
                              //  menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                            //}}
                            styles={customStylesSelect}
                          />
                        </div>
                      </div>
                    </div>
                    <div className="row m-0 text-center"> 
                      <div className="col-lg-12 col-sm-12 col-12">
                        <div className="form-group m-0">
                          <label className="text-small p-0 m-0" />
                          <div className="card-tools">
                            <button type="button" 
                                    className="btn btn-primary"
                                    id="Search_Report"
                                    onClick={onclickSearch}
                            >
                              <i className="fas fa-search" /> Search
                            </button>
                            {" "}
                            <button type="button"
                              className="btn btn-default"
                              onClick={onclickReset}
                            >
                              <i className="fas fa-times" /> reset
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                {/* /.col */}

            {_listReport && (
              <>
                <div className="row mt-3">
                  <div className="col-md-12">
                    <div className="card  card-outline shadow">
                      <div className="card-body table-responsive p-0">
                      <GridComponent
                        id="GC-Export"
                        dataSource={listReport}
                        allowPaging={true}
                        allowSorting={true}
                        allowResizing={true}
                        allowReordering={true}
                        pageSettings={{ pageCount: ConfigETC.pageCount , pageSize: ConfigETC.rowsPerPage}}
                        ref={(grid) => (gridInstance = grid)}
                        toolbar={datagridtoolbarOptions(listReport)}
                        allowExcelExport={true}
                        allowPdfExport={true}
                        allowGrouping={false}
                        toolbarClick={toolbarClick.bind(this)}       
                        //className={gridClassName} 
                        beforePrint={beforePrint.bind(this)}
                       >                      
                          <ColumnsDirective>
                          <ColumnDirective
                              field="rowindex"
                              headerText="#"
                              width="5%"
                              textAlign="left"
                            ></ColumnDirective>

                              <ColumnDirective 
                                field="task_name"
                                headerText="Task"
                                width="10%"
                              > 
                              </ColumnDirective>
                              <ColumnDirective 
                                field="tasksub_name"
                                headerText="Sub Task"
                                width="10%"
                              >
                              </ColumnDirective>
                              <ColumnDirective 
                                field="pro_cnt_str"
                                headerText="Project"
                                width="10%"
                                format="N"
                                valueAccessor={HideValue}
                              >                
                              </ColumnDirective>
                              <ColumnDirective 
                                field="work_time"
                                headerText="Work time"
                                width="10%"
                                headerTemplate={faclockTemplate}
                                valueAccessor={valueAccessDHM}
                              >
                              </ColumnDirective>

                              {isSVOT &&
                              <ColumnDirective 
                                field="over_time"
                                headerText="Over time"
                                width="10%"
                                headerTemplate={falightTemplate}
                                valueAccessor={valueAccessDHM}
                              >
                              </ColumnDirective>
                              }


                              {isPstimesheetcostsview && (
                                <ColumnDirective 
                                  field="work_time_costs_str"
                                  headerText="Work time Costs"
                                  width="10%"
                                  format="N2"
                                  headerTemplate={fabtcTemplate}
                                  valueAccessor={HideValue}
                                />
                               )}
                               {isPstimesheetcostsview && isSVOT && (
                              <ColumnDirective 
                                field="over_time_costs_str"
                                headerText="Over time Costs"
                                width="10%"
                                format="N2"
                                headerTemplate={fabtcTemplate}
                                valueAccessor={HideValue}
                                />
                              )}

                              <ColumnDirective
                                field="extra_str"
                                headerText="Per diem allowance"
                                width="15%"
                                headerTemplate={fabtcTemplate}
                                valueAccessor={HideValue}
                                format="N2"
                              > 
                              </ColumnDirective>
                              <ColumnDirective
                                field="extra_day_str"
                                headerText="Per diem allowance (day)"
                                width="17%"
                                valueAccessor={HideValue}
                                format="N2"
                              > 
                              </ColumnDirective>
                              

                              <ColumnDirective 
                                field="travel_str"
                                headerText="Travel"
                                width="10%"
                                headerTemplate={fabtcTemplate}
                                valueAccessor={HideValue}
                                format="N2"
                              >
                              </ColumnDirective>
                              <ColumnDirective 
                                field="travel_distance_str"
                                headerText="Travel (distance)"
                                width="10%"
                                valueAccessor={HideValue}
                                format="N2"
                              >
                              </ColumnDirective>


                              <ColumnDirective 
                                field="other_str"
                                headerText="Other"
                                width="10%"
                                headerTemplate={fabtcTemplate}
                                valueAccessor={HideValue}
                                format="N2"
                              >
                              </ColumnDirective>
                              </ColumnsDirective>
                          <Inject
                            services={[
                              Page,
                              Sort,
                              Toolbar,
                              ExcelExport,
                              PdfExport,
                              Group,
                              Resize,
                              Reorder ,
                            ]}
                          />
                        </GridComponent>                    
                      </div>
                    </div> {/* /.card */}
                  </div>
                  {/* /.row (main row) */}
                </div>{/* /.container-fluid */}
                </>
                 )}
              </div>
            </section>
            {/* /.content */}
          </div>
          {/* /.content-wrapper */}
      </>
        );
  }


export default Report_sumByTasks;